import css from 'styled-jsx/css'
import { colors, measurements } from 'theme'

export default css`
  .overlay-container {
    position: relative;
  }
  .overlay-content {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(2px);
    background-color: ${colors.alpha(colors.gray, 0.5)};
  }
  .overlay-content-box {
    margin: 1.5rem;
    max-width: 30rem;
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 1.5rem 0.1rem ${colors.alpha(colors.black, 0.5)};
    border-radius: ${measurements.borderRadius};
  }
  .overlay-content-box :global(.simple-login-container-background) {
    border-radius: ${measurements.borderRadius};
  }
  .overlay-content-box :global(.simple-login-container-background .simple-login-container) {
    padding: 2rem 1.5rem;
  }
  @media screen and (min-width: 772px) {
    .overlay-content {
      background-color: ${colors.alpha(colors.black, 0.65)};
    }
  }
`